import { isEqual, isString, isNumber } from 'lodash';
import { useCallback, useEffect, useState } from 'react';
import useEntityFormContext from '../../components/containers/EntityForm/internal/useEntityFormContext';
const useFieldReset = (fieldName, dependsOn = {}, value = null, enableReset = true, setTouched = true) => {
    const { setFieldValue, setFieldTouched, getFieldProps, } = useEntityFormContext();
    const [deps, setDeps] = useState(dependsOn);
    const { onChange } = getFieldProps(fieldName);
    const effect = useCallback(() => {
        setFieldValue && setFieldValue(fieldName, value);
        setTouched && setFieldTouched && setFieldTouched(fieldName);
        const inputValue = isString(value) || isNumber(value) ? String(value) : '';
        onChange && onChange(inputValue);
    }, [setTouched, setFieldValue, setFieldTouched, fieldName, value, onChange]);
    useEffect(() => {
        if (!isEqual(deps, dependsOn)) {
            setDeps(dependsOn);
            if (enableReset) {
                effect();
            }
        }
    }, [dependsOn, deps, effect, enableReset]);
};
export default useFieldReset;
